import Error from 'next/error'
import React, { useEffect } from 'react'
import { AppLayout } from 'src/common/components/Layout/AppLayout'
import { ProductDetail } from 'src/common/components/Product/ProductDetail'
import { trackView } from 'src/common/lib/segment'
import { ViewEventProps } from 'src/common/lib/segment/types'
import { prependAssetHostChallenge } from 'src/common/utils'
import { getEventById } from 'src/services/mainAPI'
import { JoinEventRes } from 'src/services/types/joinEventV2'
import { ILoginUser } from 'src/services/types/user'
import { wrapper } from 'src/store'

type StoreDetailProps = {
    item: JoinEventRes
    error: any | null
    user?: ILoginUser
}

const StoreDetail = ({ item, error, user }: StoreDetailProps) => {
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const eventProps: ViewEventProps = {
                productData: item,
                user: user
            }
            trackView(eventProps)
        }
    })

    if (error) {
        return <Error statusCode={500} />
    }

    return (
        <AppLayout
            pageTitle={item?.summary?.name}
            metaDescription={item?.summary?.metaDescription}
            metaKeywords={item?.summary?.metaKeywords}
            metaImage={prependAssetHostChallenge(item.summary.imageUrl)}
            metaTitle={`${item?.summary?.name} | Yes.Fit`}
        >
            <ProductDetail item={item} challengeId={item.summary.challengeUrl} />
        </AppLayout>
    )
}

export const getServerSideProps = wrapper.getServerSideProps(
    (store) => async (context) => {
        const { id } = context.params
        const user = store.getState().user.data ?? null
        const challengeUrl = id as string
        const { data, error } = await store.dispatch(getEventById.initiate(challengeUrl))

        return { props: { item: data ?? null, user: user, error: error ?? null } }
    }
)

export default StoreDetail
